<template lang="pug">
    v-container(grid-list-lg)
        v-layout.align-items-end.mt-2(raw wrap)
            v-flex(xs12)

                // Back button
                back-component.ml-0.pl-0(back)

            v-flex(xs12)

                // Session title
                title-component(:title="session.title")

        v-layout(raw wrap)
            v-flex(xs12)
                div.videoWrapper

                    div(id="videoAndChat")
                        div.videoWrapperInner.playerFont

                            // Video Player
                            video-player-component(
                                ref="videoPlayer"
                                id="videoPlayer"
                                class="videoPlayer"
                                :options="videoOptions"
                                :onPlayerReady="onPlayerReady"
                            )

                    session-info(:session="session")
</template>

<script>
    import ButtonBack from '~components/ButtonBack';
    import Separator from '~components/Separator';
    import Status from '~components/Status';
    import Title from '~components/Title';
    import VideoPlayer from '~components/VideoPlayer';
    import ToggleFullscreen from '~components/ToggleFullscreen';
    import VueTypes from 'vue-types';
    import SessionInfo from './SessionInfo';

    export default {
        components: {
            SessionInfo,
            VideoPlayerComponent: VideoPlayer,
            ToggleComponent: ToggleFullscreen,
            TitleComponent: Title,
            StatusComponent: Status,
            SeparatorComponent: Separator,
            BackComponent: ButtonBack
        },
        props: {
            id: VueTypes.string.def(''),
            theme: VueTypes.string.def(''),
            session: VueTypes.string.def('')
        },
        computed: {
            videoOptions() {
                const file =
                    this.session?.awsdata?.upstreamChannel?.outputs?.length > 0
                        ? this.session?.awsdata?.upstreamChannel?.outputs[0]
                              ?.url
                        : null;

                const options = {
                    file
                };

                if (this.session?.startTime)
                    options.start = this.session?.startTime;
                if (this.session?.endTime) options.end = this.session?.endTime;

                return options;
            }
        },
        methods: {
            onPlayerReady(player) {
                player.api('play');
                player.api('unmute');
                player.api('volume', 0.8);
            }
        }
    };
</script>

<style lang="stylus" scoped>
    @import '../../../../assets/style/_variables.styl'
    @import "../../../../assets/style/_mixins.styl"

    .playerFont
        >>> span
            font-size: 18px !important

    .videoWrapper
        position: relative
        border-radius: 10px
        overflow: hidden

    .sessionHeader
        display: flex
        align-items: center
        flex-direction: row
        margin-bottom: 10px

    .sessionTheme
        font-size: remify(20px)
        font-weight: 300

    .comingSoonWrapper
        display: flex
        background-color: $theme.black


    .videoWrapperInner
        position: relative
        width: 100%

    #videoAndChat
        display: flex
        width: 100%
        justify-content: center
        align-items: center

    .videoPlayer
        height: 522px
        width: 100%

        &.fullScreenVideo
            // See ViewSession.vue — 100vh on edge-to-edge Android lands
            // the playerjs control bar behind the gesture nav.
            height: calc(100vh - env(safe-area-inset-top, 0px) - env(safe-area-inset-bottom, 0px))

    @media screen and (min-width: $grid-breakpoints.xl)
        .videoPlayer
            height: 800px

    @media screen and (max-width: $grid-breakpoints.lg - 1)
        .videoPlayer
            height: 387px

    @media screen and (max-width: $grid-breakpoints.md - 1)
        .videoPlayer
            height: 460px

        .sessionHeader
            flex-direction: column
            align-items: flex-start

        .statusWrapper
            margin-top: 5px
            order: 2

        .comingSoonWrapper
            .comingSoonBackground
                margin: 0

                .comingSoon
                    .title
                        font-size 26px !important

    @media screen and (max-width: $grid-breakpoints.md - 1)
        .videoPlayer
            height: 340px
</style>
